import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { useAdminUsers } from "@features/admin/users";
import {
  ChangePasswordRequest,
  SetUserRoleRequest,
  UpdateUserNotificationSettingsRequest,
} from "@features/admin/users/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { passwordChangeSchema } from "./schemas";
import { FlexLoader } from "@components/loader";
import { CustomSelect, SelectOption } from "@components/select";
import { useEffect, useState } from "react";

type UserLoginChangeModalProps = {
  isModalOpen: boolean;
  hideModal: () => void;
};

export const UserLoginChangeModal = ({
  hideModal,
  isModalOpen,
}: UserLoginChangeModalProps) => {
  const { control } = useForm();

  return (
    <Modal isOpen={isModalOpen} onClose={hideModal} title={"Изменение логина"}>
      <div style={{ marginBottom: "10px" }}>
        <Input control={control} label="Логин" name="login"></Input>
      </div>
      <Button>Сохранить</Button>
    </Modal>
  );
};

type UserPasswordChangeModalProps = {
  isModalOpen: boolean;
  hideModal: () => void;
  userId: string;
};

export const UserPasswordChangeModal = ({
  hideModal,
  isModalOpen,
  userId,
}: UserPasswordChangeModalProps) => {
  const { state, changeUserPassword } = useAdminUsers();
  const { control, handleSubmit } = useForm<ChangePasswordRequest>({
    defaultValues: {
      user_id: userId,
    },
    resolver: yupResolver(passwordChangeSchema),
  });

  const onSubmit = (data: ChangePasswordRequest) => {
    changeUserPassword(data).then(() => {
      hideModal();
    });
  };

  return (
    <Modal isOpen={isModalOpen} onClose={hideModal} title={"Изменение пароля"}>
      {state.isModalLoading ? (
        <FlexLoader />
      ) : (
        <form>
          <div style={{ marginBottom: "15px" }}>
            <Input
              control={control}
              label="Новый пароль"
              name="new_password"
            ></Input>
          </div>
          <Button onClick={handleSubmit(onSubmit)}>Сохранить</Button>
        </form>
      )}
    </Modal>
  );
};

type User2FAChangeModalProps = {
  isModalOpen: boolean;
  hideModal: () => void;
  userId: string;
};

export const User2FAChangeModal = ({
  hideModal,
  isModalOpen,
  userId,
}: User2FAChangeModalProps) => {
  const { state, resetUserTOTP } = useAdminUsers();

  const confirmReset = () => {
    resetUserTOTP({ user_id: userId }).then(() => {
      hideModal();
    });
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title={"Подтверждение сброса 2FA"}
    >
      {state.isModalLoading ? (
        <FlexLoader />
      ) : (
        <>
          <div
            style={{ marginBottom: "10px", width: "100%", textAlign: "center" }}
          >
            Вы уверены?
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button onClick={confirmReset}>Да</Button>
            <Button onClick={hideModal}>Нет</Button>
          </div>
        </>
      )}
    </Modal>
  );
};

// type UserActivateModalProps = {
//   isModalOpen: boolean;
//   hideModal: () => void;
//   userId: string;
// };

/* export const UserActivateModal = ({
  hideModal,
  isModalOpen,
  userId,
}: UserActivateModalProps) => {
  const { state, getAdminUserRoles, activateUser, getAdminUserInfo } =
    useAdminUsers();
  const [options, setOptions] = useState<SelectOption[]>([]);
  const { control, handleSubmit } = useForm<ActivateUserRequest>({
    defaultValues: {
      user_id: userId,
      // role_id: "",
    },
  });

  useEffect(() => {
    getAdminUserRoles();
  }, [getAdminUserRoles]);

  useEffect(() => {
    setOptions(
      state.roles.map((role) => ({ text: role.name, value: role.id }))
    );
  }, [state.roles]);

  const onSubmit = (data: ActivateUserRequest) => {
    if (data.user_id != null) {
      activateUser(data).then(() => {
        // store.dispatch(
        //   // updateActivatedUser({ role: data.role_id, status: "Активен" })
        // );
        getAdminUserInfo(data.user_id);
      });
    }
    hideModal();
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title="Активация пользователя"
    >
      <form>
        { <CustomSelect
          options={options}
          control={control}
          // name="role_id"
        ></CustomSelect>}
        <Button onClick={handleSubmit(onSubmit)} style={{ marginTop: "10px" }}>
          Активировать
        </Button>
      </form>
    </Modal>
  );
}; */
type UserTGGroupModalProps = {
  isModalOpen: boolean;
  hideModal: () => void;
  userId: string;
};
export const UserTGGroupModal = ({
  isModalOpen,
  hideModal,
  userId,
}: UserTGGroupModalProps) => {
  const { updateUserNotificationSettings, getAdminUserInfo } = useAdminUsers();
  const { control, handleSubmit } =
    useForm<UpdateUserNotificationSettingsRequest>({
      defaultValues: {
        telegram_chat_id: "",
      },
    });

  const onSubmit = (data: UpdateUserNotificationSettingsRequest) => {
    // if (data.user_id != null) {
    updateUserNotificationSettings(userId, data).then(() => {
      // getAdminUserInfo(data.user_id);
      getAdminUserInfo(userId);
    });
    // }
    hideModal();
  };
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title="Активация пользователя"
    >
      <form>
        <div style={{ marginBottom: "15px" }}>
          <Input
            control={control}
            label="telegram_chat_id"
            name="telegram_chat_id"
          ></Input>
        </div>
        <Button onClick={handleSubmit(onSubmit)} style={{ marginTop: "10px" }}>
          Изменить
        </Button>
      </form>
    </Modal>
  );
};
type UserSetRoleModalProps = {
  isModalOpen: boolean;
  hideModal: () => void;
  userId: string;
};

export const UserSetRoleModal = ({
  hideModal,
  isModalOpen,
  userId,
}: UserSetRoleModalProps) => {
  const { state, getAdminUserRoles, setUserRole, getAdminUserInfo } =
    useAdminUsers();
  const [options, setOptions] = useState<SelectOption[]>([]);
  const { control, handleSubmit } = useForm<SetUserRoleRequest>({
    defaultValues: {
      role: "",
    },
  });

  useEffect(() => {
    getAdminUserRoles();
  }, [getAdminUserRoles]);

  useEffect(() => {
    setOptions(
      state.roles.map((role) => ({ text: role.name, value: role.id }))
    );
  }, [state.roles]);

  const onSubmit = (data: SetUserRoleRequest) => {
    setUserRole(userId, data).then(() => {
      // store.dispatch(updateUserRole(data.role));
      getAdminUserInfo(userId);
      hideModal();
    });
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title="Установить роль пользователя"
    >
      {state.isModalLoading ? (
        <FlexLoader />
      ) : (
        <form>
          <CustomSelect
            options={options}
            control={control}
            name="role"
          ></CustomSelect>
          <Button
            onClick={handleSubmit(onSubmit)}
            style={{ marginTop: "10px" }}
          >
            Активировать
          </Button>
        </form>
      )}
    </Modal>
  );
};
